import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Resolves the active restaurant id for admin pages.
 * URL param takes priority so super-admin "Manage" navigation works immediately.
 * Then auth-resolved id (linked profile preferred over tenant subdomain).
 */
export const useEffectiveRestaurantId = () => {
  const [searchParams] = useSearchParams();
  const { restaurantId: authRestaurantId, linkedRestaurantId } = useAuth();
  const paramRestaurantId = searchParams?.get('restaurant_id');
  return paramRestaurantId || linkedRestaurantId || authRestaurantId || null;
};

export default useEffectiveRestaurantId;
